import { App } from "vue";
import router from "@/router";

import * as Sentry from "@sentry/vue";

export default function (app: App) {
  if (import.meta.env.VITE_APP_ENV === "development") return;

  Sentry.init({
    app,
    dsn: "https://4e2a1bad4d02c37afa9369a2df709669@o4510280337915904.ingest.us.sentry.io/4510280341323776",
    environment: import.meta.env.VITE_APP_ENV || "development",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
      Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
    ],
    // Tracing
    tracesSampleRate: 1.0, // Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,
    // Logs
    enableLogs: true,
  });
}
